import { createFileRoute, notFound, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/reports/closed-days')({
  component: ClosedDaysReportLayout,
  loader: ({ context, params }) => {
    if (
      !context.ability.can('access', 'global') ||
      !context.ability.can('view', 'closed-days-report')
    ) {
      throw notFound()
    }

    if (+params.orgId === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)) {
      throw redirect({
        to: '/$orgId/reports',
        params: { orgId: params.orgId },
      })
    }
  },
})

function ClosedDaysReportLayout() {
  return <Outlet />
}
